import { createSelector } from "reselect";

const invitationState = (state) => state.invitations;

export const selectAllInvitations = createSelector(invitationState, (invitations) => invitations.all.items);

export const selectAllInvitationsLoading = createSelector(invitationState, (invitations) => invitations.all.loading);

export const selectInvitationsPagination = createSelector(invitationState, (invitations) => invitations.pagination);
